import { toast, ToastPosition } from '@elliemae/ds-toast';

export enum CustomToastType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export const triggerToast = (
  type: CustomToastType,
  messageTitle: string,
  messageText: string,
  options?: {
    onOpen?: () => void;
    onClose?: () => void;
    autoClose?: number;
  },
) => {
  toast(
    {
      type,
      messageTitle,
      messageText,
    },
    {
      position: ToastPosition.TOP_RIGHT,
      autoClose: options?.autoClose ?? 5000,
      onOpen: options?.onOpen,
      onClose: options?.onClose,
    },
  );
};
